import clsx from "clsx";
import { FC } from "react";

import { CourseGroupingView } from "./CourseGroupingView";
import { CourseNavList } from "./CourseNavList";

import type { SectionViewOption } from "components/menus/SectionViewOptionMenu";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectHasCourses, selectIsEditModeEnabled } from "store/selectors";

type CourseViewProps = { onOptionChange: (option: SectionViewOption) => void };

export const CourseView: FC<CourseViewProps> = ({ onOptionChange }) => {
  const hasCourses = useAppSelector(selectHasCourses);
  const editModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const isSmallScreen = !useIsMdOrLarger();

  return (
    <div
      className={clsx(
        "flex h-full w-full items-start",
        isSmallScreen && "flex-col overflow-y-auto pb-4",
      )}
    >
      {(hasCourses || editModeEnabled) && <CourseNavList onOptionChange={onOptionChange} />}

      <main className={clsx("w-full", !isSmallScreen && "h-full flex-auto overflow-y-auto")}>
        <CourseGroupingView />
      </main>
    </div>
  );
};
